module.exports = __webpack_public_path__ + "bef1516bf8f55d4c3244bf4151093d3a.png";